/** 临时方案，待私有化支持 im 时再优化  */
import eventBus from 'page/MeetingSchedule/utils/event';

export const useListenScheduleChange = () => {
  const addListener = (cb: () => void) => {
    eventBus.addListener('roomScheduleChange', cb);
  };

  const removeListener = () => {
    eventBus.removeAllListeners('roomScheduleChange');
  };

  const emitScheduleChange = () => {
    eventBus.emit('roomScheduleChange');
  };

  return {
    addListener,
    removeListener,
    emitScheduleChange
  };
};
